import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { Router } from '@angular/router';

@Component({
  selector: 'ms-coming-soon',
  templateUrl: './coming-soon-component.html',
  styleUrls: ['./coming-soon-component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ComingSoonComponent {



  images = [
    'assets/img/sl1.jpg',
    'assets/img/sl2.jpg',
    'assets/img/sl3.jpg',
    'assets/img/sl4.jpg',
    'assets/img/sl5.jpg',
    'assets/img/sl6.jpg',
    'assets/img/sl7.jpg',
    'assets/img/sl8.jpg',
    'assets/img/sl9.jpg',
    'assets/img/sl10.jpg',

    // Add more image paths as needed
  ];
  text = [
    "Working for an MNC there's never enough time for an individual to lookup on his health..The doctors and staff at Narayan Dham make sure that all the time you've take out is utilized in proper treatments. Each patient is provided with a timely schedule of all the various ayurvedic and naturopathy treatments he has to take, along with a proper and healthy diet.Overall.. it was a great experience here..!",
    "SHREE Nayan Dham is a very good Naturopathy & Ayurvedic Wellness Centre. The location of the place is very serene, the staff is very efficient, the whole place is hygienic, rooms are good enough, the food is outstanding. Various therapies & solutions are offered. The whole package is very reasonable also. I would recommend to visit the place twice a year, whether you are fit or unfit, you should detox yourself."

  ];

  img = [
    'assets/img/user-1.jpg',

    // Add more image paths

  ];


  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "arrows": false
  };

  constructor(
    public translate: TranslateService,
    private router: Router) { }

  currentSlide = 0;
  containerPosition = 0;
  imageContainerWidth: number;

  navigateToHome() {
    // Navigate to the current route (refresh the page)
    this.router.navigate(['/coming-soon']);
  }

  ngOnInit() {
    // Calculate the total width of the image container
    this.imageContainerWidth = this.images.length * 100;
    setInterval(() => {
      this.nextSlide();
    }, 3000);
  }

  showSlide() {
    // Update the left position of the image container
    this.containerPosition = -this.currentSlide * 100;
  }


  prevSlide(): void {
    this.images.push(this.images.shift()); // Move the first image to the end of the array
    this.text.push(this.text.shift());
  }

  nextSlide(): void {
    this.images.push(this.images.shift()); // Move the first image to the end of the array
    this.text.push(this.text.shift());
  }

  // About details
  isAbout = false;
  isHistory = false;
  isObjectofthetrust = false;
  isTrustees = false;
  isDoctors = false;
  isAdayAtAshram = false;
  isThingstoCarry = false;
  isRules = false;
  isLocation = false;
  isNatureCure = false;
  isTestimonials = false;
  isWorkshops = false;
  
  GetAboutDetails(Type) {
    this.isAbout = false;
    this.isHistory = false;
    this.isObjectofthetrust = false;
    this.isTrustees = false;
    this.isDoctors= false;
    this.isAdayAtAshram = false;
    this.isThingstoCarry = false;
    this.isRules =  false;
    this.isLocation = false;
    this.isNatureCure = false;
    this.isTestimonials = false;
    this.isWorkshops = false;

    if (Type == 'History') {
      this.isAbout = true;
      this.isHistory = true;
    } else if (Type == 'Objectofthetrust') {
      this.isAbout = true;
      this.isObjectofthetrust = true;
    } else if (Type == 'Trustees') {
      this.isAbout = true;
      this.isTrustees = true;
    }else if (Type == 'Doctors') {
      this.isAbout = true;
      this.isDoctors = true;
    }else if (Type == 'AdayAtAshram') {
      this.isAbout = true;
      this.isAdayAtAshram = true;
    }else if (Type == 'ThingstoCarry') {
      this.isAbout = true;
      this.isThingstoCarry = true; 
    }else if (Type == 'Rules') {
      this.isAbout = true;
      this.isRules = true; 
    }else if (Type == 'Location') {
      this.isAbout = true;
      this.isLocation = true; 
    }else if (Type == 'NatureCure') {
      this.isAbout = true;
      this.isNatureCure = true; 
    }else if (Type == 'Testimonials') {
      this.isAbout = true;
      this.isTestimonials = true; 
    }
    else if (Type == 'Workshops') {
      this.isAbout = true;
      this.isWorkshops = true; 
    }
  }

    // therapies Details
    istherapies = false;
    istreatmentphilosopy = false;
    istreatments = false;

  GettherapiesDetails(T) {
    this.istherapies = false;
    this.istreatmentphilosopy = false;
    this.istreatments = false;
    this.isAbout = false;

    if (T == 'treatmentphilosopy') {
      this.istherapies = true;
      this.istreatmentphilosopy = true;
    } else if (T == 'treatments') {
      this.istherapies = true;
      this.istreatments = true;
    }
  }

  //tariff Details

  istariff = false;
   
  GettariffDetails(Type){
    this.istariff= false;
    this.isAbout = false;
    this.istherapies = false;

    if(Type=='tariff'){
      this.istariff= true ;

    }
  }
 
    

   
  

}